define("vm-contactus", [], function () {
    function ContactUs() {

        var self = this;

        // Private Variables
        var placeholder = "send-feedback-messages";

        // Public Enums
        self.contactTypes = cccApp.enums.contactUsTypes;

        // Observables
        self.isSendingMessage = ko.observable(false);
        self.hasSentMessage = ko.observable(false);

        self.userName = "";
        self.hostName = ko.observable("");
        self.hostGuid = ko.observable("");

        self.name = ko.observable("");
        self.email = ko.observable("");
        self.message = ko.observable("");
        self.selectedOption = ko.observable(self.contactTypes.Suggestion);

        //Computeds
        self.isFormEnabled = ko.computed(function() {
            return !self.isSendingMessage() && !self.hasSentMessage();
        });

        self.isNameEnabled = ko.computed(function() {
            return self.isFormEnabled() && !self.userName;
        });

        self.isSendEnabled = ko.computed(function() {
            return ((self.userName || $.trim(self.name()).length > 0)
                && (self.userName || $.trim(self.email()).length > 0)
                && $.trim(self.message()).length > 0
                && !self.isSendingMessage());
        });

        // Public Functions
        self.init = function() {
            if (typeof cccApp !== "undefined" && cccApp !== null) {
                if (cccApp.user) {
                    self.email(cccApp.user.email());
                    self.name(cccApp.user.displayName());
                    self.userName = cccApp.user.email();
                }
                if (cccApp.computer) {
                    self.hostName(cccApp.computer.name);
                    self.hostGuid(cccApp.computer.guid);
                }
            }
        };

        self.render = function() {
            if (self.hasSentMessage()) {
                self.reset();
            }
        };

        self.reset = function() {
            if (typeof cccApp !== "undefined" && cccApp !== null) {
                if (cccApp.user) {
                    self.email(cccApp.user.email());
                    self.name(cccApp.user.displayName());
                }
                if (cccApp.computer) {
                    self.hostName(cccApp.computer.name);
                    self.hostGuid(cccApp.computer.guid);
                }
            } else {
                self.name("");
                self.email("");
            }

            self.message("");
            self.selectedOption(1);
            self.isSendingMessage(false);
            self.hasSentMessage(false);
        };

        self.submit = function() {
            var issue = {};
            issue.userName = (self.userName) ? self.userName : self.name();
            issue.userEmail = self.email();
            issue.description = self.message();
            issue.type = self.selectedOption();
            issue.sourceUrl = window.location.href;

            issue.computerName = self.hostName();
            issue.computerId = self.hostGuid();
            issue.sourceDetailed = (self.userName) ? self.sourceDetailed() : "";

            var jsonData = ko.toJSON(issue);

            self.isSendingMessage(true);

            cccApp.api.post({
                url: "service/support/contactus",
                data: jsonData,
                messagePlaceholder: placeholder,
                success: function(result) {
                    if (result.error && result.error.code === cccApp.api.codes.SUCC_Success) {
                        self.reset();
                        self.hasSentMessage(true);
                        cccApp.msg.success(result.error.message, placeholder);
                    } else {
                        cccApp.msg.error(result.error.message, placeholder);
                    }
                },
                complete: function() { self.isSendingMessage(false); }
            });
        };

        self.sourceDetailed = function() {

            var currentPath = Path.routes.current;
            var elementPath = "";

            var elements = $(".tab-content:visible");

            if (elements && elements.length > 0) {
                for (var i = 0; i < elements.length; i++) {
                    if (elements[i]) {
                        elementPath += elements[i].id + (i === (elements.length - 1) ? "" : ",");
                    }
                }
            }

            return "URL Path: " + currentPath + " Visible Tab(s): " + elementPath;
        };

        self.close = function() {
            cccApp.closePopup();
        };
    }

    return ContactUs;
});